import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useGlobalState } from 'contexts/global-state'
import { useNavigate, useParams } from 'react-router-dom'
import { ApiService } from 'services/api'

import Add from './add'

export default function Edit() {
  const { id } = useParams<{ id: string }>()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const { openSuccessToast, openErrorToast } = useGlobalState()

  const { data } = useQuery<Clients>(
    QUERY_KEYS.CLIENTS.EDIT(id as string),
    () => ApiService.Clients.get(id as string),
  )

  const updateClient = useMutation({
    mutationFn: async ({
      id,
      client,
    }: {
      id: string
      client: ClientsApiRequest
    }) => {
      await ApiService.Clients.update({
        id,
        client,
      })
    },
    onSuccess: (_data, { id, client }) => {
      queryClient.setQueryData<ClientsApiRequest>(
        QUERY_KEYS.CLIENTS.EDIT(id),
        (oldClient) => {
          if (!oldClient) return
          return client
        },
      )

      openSuccessToast({
        message: `O cliente ${client.fantasy_name} foi atualizado com sucesso!`,
      })

      navigate(ROUTES.CLIENTS.LIST)
    },
    onError: (_error, { client }) => {
      openErrorToast({
        message: `Erro ao editar ${client.fantasy_name}!`,
      })
    },
  })

  return (
    <Add
      clients={data}
      isEditMode
      onSave={async (client: ClientsApiRequest) =>
        updateClient.mutate({ id: id as string, client })
      }
    />
  )
}
